import * as types from "./actionTypes";
import simulatiePerInfrastructuurApi from "../api/simulatiePerInfrastructuurApi";
import * as constants from "../constants/DomainConstants";
import * as ajax from "./ajaxCounterActions";
import * as exception from "./exceptionActions";
import * as beads from "./beadActions";
import geographyApi from "../api/geographyApi";

import * as dossier from "../actions/simulatieDossierActions";

export function getEmptySportinfrastructuurInDeBuurt() {
	return (dispatch) => {
		dispatch(ajax.started());
		return simulatiePerInfrastructuurApi.getNewInfrastructuur()
			.then(response => {
				dispatch(ajax.ended());
				return response.data;
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				dispatch(exception.throwException(error));
			});
	};
}

export function getGeoCoordinates(adres) {
	return (dispatch) => {
		dispatch(ajax.started());

		return geographyApi.getCoordinatenForAdres(adres)
			.then(response => {
				dispatch(ajax.ended());
				return response.data;
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				dispatch(exception.throwException(error));
			});
	};
}

export function simulatiePerInfrastructuurCacheSaved(bovenLokaliteitPerInfrastructuur, documenten, fileSessionStarted, isSaved) {
	return {
		type: types.SIMULATIE_PER_INFRASTRUCTUUR_CACHE_SAVED,
		body: {
			item: bovenLokaliteitPerInfrastructuur,
			documenten: documenten,
			fileSessionStarted: fileSessionStarted,
			isSaved: isSaved
		}
	};
}


export function infrastructuurInDeBuurtValidated(validationErrors) {
	return {
		type: types.SIMULATIE_PER_INFRASTRUCTUUR_VALIDATED,
		body: {
			errors: validationErrors
		}
	};
}

export function saveSimulatietPerInfrastructuurCache(simulatiePerInfrastructuur, documenten, fileSessionStarted, isSaved) {
	return (dispatch) => {
		dispatch(ajax.started());
		return simulatiePerInfrastructuurApi.validateSimulatiePerInfrastructuur(simulatiePerInfrastructuur)
			.then(response => {
				dispatch(ajax.ended());
				if (Object.keys(response.data.validationResults).length !== 0) {
					dispatch(infrastructuurInDeBuurtValidated(response.data.validationResults));
					return constants.HAS_VALIDATION_ERRORS;
				}
				else {
					simulatiePerInfrastructuur.tienMinutenWandelen = response.data.item.tienMinutenWandelen;

					//TODO ERWIN ADD
					dispatch(dossier.simulatieInfrastructuurSaved(simulatiePerInfrastructuur));

					dispatch(simulatiePerInfrastructuurCacheSaved(simulatiePerInfrastructuur, documenten, fileSessionStarted, isSaved));
					return constants.SUCCESS_NO_TOASTR;
				}
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				dispatch(exception.throwException(error));
			});
	};
}
